const INTERCOM_SCRIPT_ID = 'intercom-script';
const INTERCOM_SRC = `https://widget.intercom.io/widget/sa8p3fk0`;

//helper functions for booting, shutting down and updating the intercom instance
const IntercomHelper = {
    load(settings = {}) {
        // if (typeof window === 'undefined') return;
        // if (window.Intercom && window.Intercom === 'function') {
        //     window.Intercom('shutdown');
        //     window.Intercom('boot', ...settings);
        // }

        window.intercomSettings = {
            app_id: 'sa8p3fk0',
            ...settings,
        };

        const isIntercomLoaded = window.Intercom && window.Intercom === 'function';
        const scriptAlreadyAdded = !!document.getElementById(INTERCOM_SCRIPT_ID);

        if (isIntercomLoaded) {
            window.Intercom('shutdown');
            window.Intercom('boot', window.intercomSettings);
            return;
        }

        if (scriptAlreadyAdded) return;

        //check if intercom script has already been loaded or not (added dom-independent guard clause in the case of logging in as other users)
        if (window.__INTERCOM_SCRIPT_ADDED__ || document.getElementById(INTERCOM_SCRIPT_ID)) return;

        window.__INTERCOM_SCRIPT_ADDED__ = true;

        const script = document.createElement('script');
        script.id = INTERCOM_SCRIPT_ID;
        script.src = INTERCOM_SRC;
        script.async = true;
        document.body.appendChild(script);

        script.onload = () => {
            if (typeof window.Intercom === 'function') {
                window.Intercom('boot', window.intercomSettings);
            }
        };
    },
    shutdown() {
        if (typeof window == 'undefined' || !window.Intercom) return;
        window.Intercom('shutdown');

        const script = document.getElementById(INTERCOM_SCRIPT_ID);
        if (script) {
            script.remove();
        }

        delete window.Intercom;
        delete window.intercomSettings;
        window.__INTERCOM_SCRIPT_ADDED__ = false;
    },

    update(data) {
        if (typeof window !== 'undefined' && typeof window.Intercom === 'function') {
            window.Intercom('update', data);
        }
    },
};

export default IntercomHelper;
